<template>
  <!-- After bulma removal, fix paddings in this file to use p-2 instead of p-0.5  -->
  <component
    :is="actualComponent"
    class="relative flex items-center justify-center gap-2 cursor-pointer rounded-[4px] font-[Nunito] transition-colors"
    :class="[
      bgColor,
      textColor,
      borderColor,
      {
        'w-full': expanded,
        '!cursor-not-allowed': disabled,
        'border-solid border-2': outline,
        'p-[0.25rem] !text-xs': size === 'sm',
        'py-[0.5rem] px-[0.75rem]': size === 'md',
        'px-[0.625rem] py-[0.625rem] !text-xl font-bold': size === 'lg',
        'px-[1.5rem] py-[1.5rem] !text-2xl font-bold': size === 'xl',
        'inline-flex': inline,
        '!p-0.5': outline && size === 'sm',
        '!py-1.5 !px-2.5': outline && size === 'md',
        '!p-3': outline && size === 'lg',
        '!p-6': outline && size === 'xl',
      },
    ]"
    :title="title"
    :type="isSubmit ? 'submit' : 'button'"
    :href="href ?? to"
    :to="to"
    v-bind="$attrs"
    @click="onClick"
  >
    <IconComponent
      v-if="iconLeft && !loading && !disabled"
      :icon="iconLeft"
      :pack="iconLeftPack"
      :class="iconLeftClass"
    />
    <IconComponent
      v-if="loading"
      icon="spinner"
      pack="fas"
      class="animate-spin"
    />
    <IconComponent v-if="disabled" icon="ban" pack="fas" />
    <slot />
    <IconComponent v-if="iconRight" :icon="iconRight" :pack="iconRightPack" />
  </component>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: null,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "info",
      validator: function (val) {
        return [
          "default",
          "info",
          "success",
          "warning",
          "danger",
          "error",
          "rating",
        ].includes(val);
      },
    },
    isSubmit: {
      type: Boolean,
      default: false,
    },
    inverted: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
      validator: function (val) {
        return ["sm", "md", "lg", "xl"].includes(val);
      },
    },
    iconLeft: {
      type: String,
      default: "",
    },
    iconLeftPack: {
      type: String,
      default: "fa",
      validator: function (val) {
        return ["fa", "fab", "fas", "far"].includes(val);
      },
    },
    iconLeftClass: {
      type: String,
      default: "",
    },
    iconRight: {
      type: String,
      default: "",
    },
    iconRightPack: {
      type: String,
      default: "fa",
      validator: function (val) {
        return ["fa", "fab", "fas", "far"].includes(val);
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    /**
     * @example bg-info hover:bg-info-darker
     * @return {string}
     */
    bgColor() {
      if (this.inverted) {
        return `bg-white dark:bg-gray-800 ${
          this.disabled ? "" : " hover:bg-white-darker dark:hover:bg-gray-700"
        }`;
      }

      if (this.type === "default") {
        if (this.disabled) {
          return "bg-gray-100/50 dark:bg-gray-700/50";
        }

        return "bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600";
      }

      return `bg-${this.type}${this.disabled ? "-lightest" : ""} hover:bg-${
        this.type
      }${this.disabled ? "-lightest" : "-darker"}`;
    },
    /**
     * @example border-info hover:border-info-darker
     * @return {string}
     */
    borderColor() {
      return `border-${this.type}${
        this.disabled ? "-lightest" : ""
      } hover:border-${this.type}${this.disabled ? "-lighter" : "-darker"}`;
    },
    /**
     * @example text-info hover:text-info-darker
     * @return {string}
     */
    textColor() {
      if (this.type === "default") {
        return `text-gray-${
          this.disabled ? "300" : "600"
        } hover:text-gray-700 dark:text-gray-400`;
      }

      if (this.type === "warning" && !this.inverted) {
        return this.disabled
          ? "text-slate-500"
          : "text-slate-800 hover:text-slate-900";
      }

      if (this.inverted) {
        return `text-${this.type}${
          this.disabled ? "-lightest" : ` hover:text-${this.type}-darker`
        }`;
      }

      return "text-white hover:text-white-darker";
    },
    actualComponent() {
      if (this.href) {
        return "a";
      }

      if (this.to) {
        return "NuxtLink";
      }

      return "button";
    },
  },
  methods: {
    onClick(e) {
      if (this.isSubmit) {
        e.preventDefault();
      }
      if (this.disabled || this.loading) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (this.href || this.to) {
        // e.preventDefault();
        e.stopPropagation();
        // location.href = this.href;
      }
      this.$emit("click", e);
    },
  },
};
</script>
